import { Select, MenuItem } from "@mui/material";
import type { Filter, Action } from "./ExState";
import ExAutocomplete from "./ExAutocomplete";
import { make as UnitImageExtended } from "common/src/tft-static/UnitImageExtended.bs";
import { common as t } from "common/src/bindings/Translation2";
import { use as useSet } from "common/src/data/TftSet.bs";
import * as Sd from "common/src/tft-static/Sd";

type FilterSelectProps = {
  value: Filter | undefined;
  options: Array<Filter>;
  dispatch: (a: Action) => void;
  getMatches: (search: string) => Array<Filter>;
  idx: number;
  disabled?: boolean;
  allFilters: Array<Filter>;
};

const FilterSelect = ({
  value,
  options,
  dispatch,
  getMatches,
  idx,
  disabled,
  allFilters,
}: FilterSelectProps) => {
  const set = useSet();
  const ufCount = allFilters.filter((f) => f.typ === "u").length;
  const allowItemFilters = ufCount > 1 || (ufCount === 1 && value?.typ !== "u");
  return (
    <div>
      <ExAutocomplete
        disabled={disabled}
        placeholder={`${t("Filter")} #${idx + 1}`}
        value={value}
        options={options}
        onChange={(v) => {
          dispatch(["set_filter", [idx, v]]);
        }}
        getMatches={getMatches}
        allowItemFilters={allowItemFilters}
      />
      {value ? (
        value.typ === "u" ? (
          <div className="flex items-center gap-3 pl-3 pt-2">
            <div>{t("Star Level")}</div>
            <Select
              value={value.starLevel}
              label="Star Level"
              onChange={(e) =>
                dispatch([
                  "set_filter",
                  [idx, { ...value, starLevel: Number(e.target.value) }],
                ])
              }
              variant="standard"
              sx={{ width: 60 }}
            >
              <MenuItem value={0}>{t("Any")}</MenuItem>
              <MenuItem value={1}>1★</MenuItem>
              <MenuItem value={2}>2★</MenuItem>
              <MenuItem value={3}>3★</MenuItem>
              {Sd.getUnitTraits(value.id, set).includes("Set9_BandleCity") ? (
                <MenuItem value={4}>4★</MenuItem>
              ) : null}
            </Select>
          </div>
        ) : value.typ === "i" ? (
          (() => {
            const selected = allFilters.findIndex(
              (f) =>
                f.typ === "u" &&
                value.unitId[0] === f.id &&
                value.unitId[1] === f.starLevel,
            );
            return (
              <div className="flex items-center gap-3 pl-3 pt-2">
                <div>{t("User")}</div>
                <Select
                  classes={{
                    select: "w-[125px] flex items-center gap-[6px]",
                  }}
                  labelId={`ex-a-aug-pick-${idx}`}
                  value={selected}
                  onChange={(e) => {
                    const pickIdx = Number(e.target.value);
                    const pick = allFilters[pickIdx];
                    if (pick.typ === "u") {
                      dispatch([
                        "set_filter",
                        [idx, { ...value, unitId: [pick.id, pick.starLevel] }],
                      ]);
                    }
                  }}
                  variant="standard"
                >
                  {allFilters.map((filter: Filter, idx) => {
                    if (filter.typ === "u") {
                      return (
                        <MenuItem
                          key={idx}
                          value={idx}
                          className="flex gap-[6px] items-center"
                        >
                          <UnitImageExtended
                            starLevel={
                              filter.starLevel !== 0
                                ? filter.starLevel
                                : undefined
                            }
                            unitId={filter.id}
                            items={[]}
                            size={22}
                          />
                          {filter.label}
                        </MenuItem>
                      );
                    } else {
                      return null;
                    }
                  })}
                </Select>
              </div>
            );
          })()
        ) : value.typ === "a" ? (
          <div className="flex items-center gap-3 pl-3 pt-2">
            <div>{t("Pick")}</div>
            <Select
              labelId={`ex-a-aug-pick-${idx}`}
              value={value.pick}
              onChange={(e) => {
                dispatch([
                  "set_filter",
                  [idx, { ...value, pick: Number(e.target.value) }],
                ]);
              }}
              variant="standard"
            >
              <MenuItem value={0}>Any</MenuItem>
              <MenuItem value={1}>2-1</MenuItem>
              <MenuItem value={2}>3-2</MenuItem>
              <MenuItem value={3}>4-2</MenuItem>
            </Select>
          </div>
        ) : (
          <div className="h-10" />
        )
      ) : (
        <div className="h-10" />
      )}
    </div>
  );
};

export default FilterSelect;
